<app-nav [route]="path"></app-nav>
<div class="container-fluid mx-auto w-100 padding-wrapper">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
